import CashbackHome from 'features/rewards/screens/CashbackHome/CashbackHome';
import React from 'react';
import SubTabErrorBoundary from 'shared/patterns/wrappers/SubTabErrorBoundary/SubTabErrorBoundary';

export default function RewardsTab() {
  return (
    <SubTabErrorBoundary>
      <CashbackHome />
    </SubTabErrorBoundary>
  );
}
